import { Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { BseStatusDto } from "../../autogen/bff-api";

interface Props {
  status: BseStatusDto;
  size?: "sm" | "md" | "lg";
}

export const EventStatusTag = ({ status, size }: Props) => {
  const { t } = useTranslation();
  const getEventTagMeta = (status: BseStatusDto): { color: string; text: string } => {
    switch (status) {
      case BseStatusDto.Awarded:
        return {
          color: "purple",
          text: t("Awarded"),
        };
      case BseStatusDto.Completed:
        return {
          color: "purple",
          text: t("Evaluation Complete"),
        };
      case BseStatusDto.Draft:
        return {
          color: "orange",
          text: t("Draft"),
        };
      case BseStatusDto.Published:
        return {
          color: "green",
          text: t("Live"),
        };
      case BseStatusDto.DeadlineHasPassed:
        return {
          color: "orange",
          text: t("Deadline passed"),
        };
      case BseStatusDto.Cancelled:
        return {
          color: "gray",
          text: t("Cancelled"),
        };
      case BseStatusDto.Closed:
        return {
          color: "blue",
          text: t("Completed"),
        };
    }
  };

  const tagMeta = getEventTagMeta(status);

  return (
    <Tag
      variant="outline"
      colorScheme={tagMeta.color}
      size={size}
      textAlign="center"
      paddingTop={"2px"}
      paddingBottom={"2px"}
    >
      {tagMeta.text}
    </Tag>
  );
};
